import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import { styled } from '../../stitches.config.js';
import { elevationVariants } from '../Elevation/Elevation.js';

var StyledCard = styled('div', {
  appearance: 'none',
  border: 'none',
  boxSizing: 'border-box',
  font: 'inherit',
  lineHeight: '1',
  outline: 'none',
  padding: '$3',
  textAlign: 'inherit',
  verticalAlign: 'middle',
  WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
  backgroundColor: '$cardBackground',
  display: 'block',
  textDecoration: 'none',
  color: 'inherit',
  borderRadius: '$3',
  position: 'relative',
  '&::before': {
    boxSizing: 'border-box',
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: '$3',
    pointerEvents: 'none'
  },
  variants: {
    elevation: elevationVariants,
    variant: {
      inner: {
        backgroundColor: 'rgba(255,255,255,.07)'
      },
      ghost: {
        backgroundColor: 'transparent',
        boxShadow: 'none'
      }
    }
  },
  defaultVariants: {
    elevation: 1
  }
});
var StyledInteractiveCard = styled('button', StyledCard, {
  '@hover': {
    '&:hover': {
      cursor: 'pointer',
      '&::before': {
        outline: '1px solid $colors$cardHoverBorder',
        backgroundColor: '$cardHoverBackground'
      }
    }
  },
  '&:focus': {
    outline: '2px solid $primary'
  },
  '&:active': {
    '&::before': {
      outline: '1px solid $colors$cardActiveBorder',
      backgroundColor: '$cardActiveBackground'
    }
  }
});
var Card = /*#__PURE__*/React.forwardRef(function (_a, forwardedRef) {
  var interactive = _a.interactive,
    props = __rest(_a, ["interactive"]);
  if (interactive) {
    return /*#__PURE__*/React.createElement(StyledInteractiveCard, __assign({
      tabIndex: 0,
      ref: forwardedRef
    }, props));
  }
  return /*#__PURE__*/React.createElement(StyledCard, __assign({
    ref: forwardedRef
  }, props));
});

export { Card };
